import type { NodeId, SourceId } from '@/core/document/types'

function createId<T extends NodeId | SourceId>(): T {
  return crypto.randomUUID() as T
}

export function createNodeId(): NodeId {
  return createId<NodeId>()
}

export function createSourceId(): SourceId {
  return createId<SourceId>()
}

export function asNodeId(value: string): NodeId {
  if (!value.trim()) throw new Error('Node id must not be empty')
  return value as NodeId
}
